<app-form-generator
    *ngIf="formGenInput && executionFunc"
    [formGeneratorInput]="formGenInput"
    (resetFormFunction)="resetForm = $event"
></app-form-generator>
